import React from "react";
import { Page, List, ListItem, SearchInput, Icon } from "react-onsenui";
import SubstancePage from "./SubstancePage";
import { getSubstances } from "../services/megamix";
import Toolbar from "../components/Toolbar";

const style = {
  searchContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  searchInput: {
    margin: "5px"
  }
};

class SubstancesIndexPage extends React.Component {
  state = {
    input: ''
  };

  popularLetters = {};
  otherLetters = {};

  pushSubstancePage(substance) {
    this.props.navigator.pushPage({
      component: SubstancePage,
      props: {
        key: `substance-${substance.id}`,
        substance: substance
      }
    });

    const newPathname = `${window.location.pathname}#substances/${substance.token}`;
    console.log("SubstancesIndexPage navigating to", newPathname);
    window.history.replaceState(
      { substance: substance.id },
      '',
      newPathname
    );
  }

  getFilteredSubstances(isPopular) {
    // leave letters, digits, hyphen, period and comma, but make them optional
    const input = this.state.input.replace(/[^a-zA-Z0-9.,\-()\s]/gm, '');
    const regexp = new RegExp(input, 'i');

    if (isPopular == null) {
      return getSubstances().filter(substance => {
        return regexp.test(substance.commonName) ||
              regexp.test(substance.name);
      });
    } else {
      return getSubstances().filter(substance => {
        return substance.isPopular == isPopular && (
          regexp.test(substance.commonName) ||
              regexp.test(substance.name));
      });
    }
  }

  renderToolbar() {
    const { navigator, showMenu } = this.props;
    return (
      <Toolbar
        pageName="Substances"
        navigator={navigator}
        showMenu={showMenu}
      />
    );
  }

  renderSubstanceRow(substance, index, letter, showLetter) {
    return (
      <ListItem
        key={substance.id}
        onClick={() => this.pushSubstancePage(substance)}
        tappable
        className="clickable"
      >
        <div className="substance-index-letter" style={showLetter ? {} : {opacity: 0}}>{letter}</div>

        <div className="testdrugs-header">{substance.name}</div>

        {/* {substance.sid == null ? null : (
                  <Icon
                    icon="info-circle"
                    size={14}
                    style={{ margin: "0 5px 0 auto", color: "#ccc" }}
                  />)} */}
      </ListItem>
    );
  }

  renderPopularSubstanceRow(substance, index) {
    const letter = substance.name.substring(0, 1).toUpperCase();
    let showLetter = false;
    if (this.popularLetters[letter] !== true) {
      showLetter = true;
      this.popularLetters[letter] = true;
    }
    return this.renderSubstanceRow(substance, index, letter, showLetter);
  }

  renderOtherSubstanceRow(substance, index) {
    const letter = substance.name.substring(0, 1).toUpperCase();
    let showLetter = false;
    if (this.otherLetters[letter] !== true) {
      showLetter = true;
      this.otherLetters[letter] = true;
    }
    return this.renderSubstanceRow(substance, index, letter, showLetter);
  }

  onSearchInputChange(event) {
    this.setState({ input: event.target.value });
  }

  render() {
    const popularSubstances = this.getFilteredSubstances(true);
    const otherSubstances = this.getFilteredSubstances(false);
    this.popularLetters = {};
    this.otherLetters = {};

    return (
      <Page renderToolbar={this.renderToolbar.bind(this)}>
        <div style={style.searchContainer}>
          <SearchInput
            value={this.state.input}
            float
            onChange={this.onSearchInputChange.bind(this)}
            placeholder="Search substances…"
            style={style.searchInput}
          />
        </div>
        <h3>Popular substances ({""+popularSubstances.length})</h3>
        <List
          dataSource={popularSubstances}
          renderRow={this.renderPopularSubstanceRow.bind(this)}
        />
        <h3>Other substances ({""+otherSubstances.length})</h3>
        <List
          dataSource={otherSubstances}
          renderRow={this.renderOtherSubstanceRow.bind(this)}
        />
      </Page>
    );
  }
}

export default SubstancesIndexPage;


